import { render, staticRenderFns } from "./ExpenseItemListHeader.vue?vue&type=template&id=72b6793e&"
import script from "./ExpenseItemListHeader.vue?vue&type=script&lang=ts&"
export * from "./ExpenseItemListHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ExpenseItemListHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports